export default "__VITE_ASSET__CxyW6GPD__"